<div class="tw-relative box-popup">
    <button (click)="closePopup('close')" class="close-button" [attr.aria-label]="'v3-button-close' | translate" buttonDataTest="closeButton">
        <app-icon name="x" class="tw-size-6"></app-icon>
    </button>
    <div class="popup-content" [perfectScrollbar]="{ suppressScrollX: true, wheelPropagation: false }">
        <img class="tw-block screen tw-w-full tw-bg-gradient-senary" src="assets/img/mobile-app-popup-image.png" alt="" />

        <div class="logo">
            <app-icon name="logo" class="tw-fill-white"></app-icon>
        </div>

        <div class="tw-px-3">
            <div class="tw-mb-8 tw-typo-h4" translate>v3-mobile-app-popup-text</div>
            <div class="tw-flex tw-justify-center tw-items-center tw-gap-6 tw-mb-10">
                <app-btn-download-mobile-app [mobileType]="'ios'"></app-btn-download-mobile-app>
                <app-btn-download-mobile-app [mobileType]="'android'"></app-btn-download-mobile-app>
            </div>
            <a
                [href]="mobileStoreAppLink"
                app-button-outline
                size="sm"
                severity="secondary"
                icon="arrow-right"
                iconPosition="right"
                [text]="'v3-global-mobile-download-popup-button-text' | translate"
                (click)="closePopup('close')"
                buttonDataTest="alreadyHaveAppButton"
            ></a>
        </div>
    </div>
</div>
